import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStylesAddClientModal = makeStyles((theme: Theme) => createStyles({
  container: {
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paper: {
    width: '800px',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    padding: '48px',
    borderRadius: '8px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
    [theme.breakpoints.down(1024)]: {
      padding: '24px',
      width: "600px",
    },
    [theme.breakpoints.down(760)]: {
      maxWidth: "600px",
      width: '100%',
      maxHeight: "100%",
      overflowY: "auto"
    },
  },
}))